
import RNModal from 'modal-react-native-web';

export const Modal = RNModal

